<div *ngIf="loaded" [ngSwitch]="typeOf">
    <div class="row-flex-3">
        <span>
            <button [mat-dialog-close]="false" aria-label="Go back" color="primary" mat-icon-button>
                <mat-icon>arrow_back</mat-icon>
            </button>
        </span>
        <div *ngIf="!object.full_name">
            <mat-card-title>{{object.name}} Info</mat-card-title>
            <mat-card-subtitle>Alerting ID:{{object.id}}</mat-card-subtitle>
        </div>
        <div *ngIf="object.full_name">
            <mat-card-title>
                {{ object.full_name }} ({{ object.external_id }})
            </mat-card-title>
            <mat-card-subtitle>
                <span *ngIf="object.id">Alerting ID: {{ object.id }}</span>
            </mat-card-subtitle>
        </div>

        <span>
            <button [mat-dialog-close]="true" aria-label="Close" class="right" color="primary" mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </span>
    </div>
    <mat-dialog-content>

        <div *ngSwitchCase="'DEVICE'">
            <div class="{{!members || members.length === 0 ? 'form-section-2' : 'form-section'}} row-flex">
                <span><label>Channel Type: </label>{{object.contact_type}}</span>
                <div *ngIf="displayAddress !== ''"><label>Channel Address: </label> {{displayAddress}}</div>
                <div *ngIf="displayAddress === ''"><label>Channel Address: </label> {{object.address}}</div>
            </div>
            <div *ngIf="members !== undefined && members.length > 0" class="form-section-2 row-flex-2">
                <label class="mr10 mt10">Member of:</label>
                <mat-chip-list>
                    <mat-chip (click)="openGroupPopup(member.id)" *ngFor="let member of members">
                        {{member.name}}</mat-chip>
                </mat-chip-list>
            </div>
        </div>

        <div *ngSwitchCase="'GROUP'">
            <div *ngIf="groupReady">
                <div class="form-section row-flex">
                        <span class="mt10">
                            <label>Group Type: </label>
                            {{getGroupTypeName(object.group_type_id)}}
                        </span>
                    <span *ngIf="escalateTo && object.escalate_to !== 'Do Not Escalate'">
                            <label class="mt10 mr10">Escalate to: </label>
                            <mat-chip (click)="openPopup(object.escalate_to)">{{object.escalate_to}}</mat-chip>
                        </span>
                    <span *ngIf="escalateTo && object.escalate_to !== 'Do Not Escalate'" class="mt10">
                            <label>Escalation Frequency: </label>
                            Every {{object.escalate_time_limit}} minutes
                        </span>
                    <span *ngIf="escalateTo && object.notification_to_id">
                            <label class="mt10 mr10">Rotation Notification to: </label>
                            <mat-chip (click)="openPopup(notification_to)">{{notification_to}}</mat-chip>
                        </span>
                </div>
                <div class="form-section row-flex-2">
                    <label class="mt10 mr10">Group Owners:</label>
                    <mat-chip-list #chipList>
                        <mat-chip (click)="openIndividualPopup(owner.id)"
                                  *ngFor="let owner of object.owners"> {{owner.full_name}}</mat-chip>
                    </mat-chip-list>
                </div>
                <div class="{{!members || members.length === 0 ? 'form-section-2' : 'form-section'}} row-flex-2">
                    <label *ngIf="object.sub_group_enabled" class="mt10 mr10">Sub-Groups:</label>
                    <label *ngIf="!object.sub_group_enabled" class="mt10 mr10">Individuals and Devices:</label>
                    <mat-chip-list aria-orientation="horizontal">
                        <mat-chip (click)="openPopup(member)"
                                  *ngFor="let member of object.members">{{ member.name }}</mat-chip>
                    </mat-chip-list>
                </div>
                <div *ngIf="members !== undefined && members.length > 0" class="row-flex-2 form-section-2">
                    <label class="mt10 mr10">Member of:</label>
                    <mat-chip-list>
                        <mat-chip (click)="openGroupPopup(member.id)"
                                  *ngFor="let member of members">{{ member.name }}</mat-chip>
                    </mat-chip-list>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="'INDIVIDUAL'">
            <div class="form-section flex-col">
                <label *ngIf="messageTypesEnabled" class="mr10 mt10">Contacts:</label>
                <div class="row-flex-2">
                    <label *ngIf="!messageTypesEnabled" class="mr10 mt10">Contacts:</label>
                    <mat-chip-list aria-label="Contacts" *ngIf="!messageTypesEnabled">
                        <mat-chip *ngFor="let contact of object.contacts" [disabled]="disabled"
                                  [removable]="false" [selectable]="false" cdkDrag class="left wdAuto">
                            <mat-icon *ngIf="contact.preferred" aria-label="Selected contact" matTooltip="Preferred Contact ({{getContactType(contact)}})">
                                check
                            </mat-icon>
                            <ng-container [ngSwitch]="getContactType(contact)">
                                <mat-icon *ngSwitchCase="SMS" aria-hidden="false" aria-label="SMS Text" matTooltip="SMS">
                                    perm_phone_msg
                                </mat-icon>
                                <mat-icon *ngSwitchCase="VOICE" aria-hidden="false" aria-label="Phone" matTooltip="Voice">
                                    phone
                                </mat-icon>
                                <mat-icon *ngSwitchCase="EMAIL" aria-hidden="false" aria-label="EMail" matTooltip="Email">
                                    email
                                </mat-icon>
                                <mat-icon *ngSwitchCase="CHAT" aria-hidden="false" aria-label="Chat" matTooltip="Chat">
                                    message
                                </mat-icon>
                            </ng-container>
                            {{ contact.address }}
                        </mat-chip>
                    </mat-chip-list>
                    <div *ngIf="messageTypesEnabled">
                        <div class="grid grid-cols-3 gap-4 divide-x divide-[var(--cmn-text-alt)] rounded-none">
                            <div class="flex flex-col w-full items-center">
                                <label class="text-center w-full ml-2">
                                    Informational Only</label>
                                <mat-chip-list #chipListInformational
                                               accessKey="informational"
                                               class="left size-full min-h-8 max-w-96 mb-1 ml-4">
                                    <mat-chip *ngFor="let contact of informationalContacts"
                                              class="w-96 flex-initial">
                                        <ng-container [ngSwitch]="getContactType(contact)">
                                            <mat-icon *ngSwitchCase="SMS" aria-hidden="false" aria-label="SMS Text" matTooltip="SMS">
                                                perm_phone_msg
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="VOICE" aria-hidden="false" aria-label="Phone" matTooltip="Voice">
                                                phone
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="EMAIL" aria-hidden="false" aria-label="EMail" matTooltip="Email">
                                                email
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="CHAT" aria-hidden="false" aria-label="Chat" matTooltip="Chat">
                                                message
                                            </mat-icon>
                                        </ng-container>
                                        {{ contact.address }}
                                    </mat-chip>
                                </mat-chip-list>
                            </div>

                            <div class="flex flex-col w-full items-center">
                                <label class="text-center w-full ml-2">
                                    Response Required Only</label>
                                <mat-chip-list #chipListResponseRequired
                                               accessKey="responseRequired"
                                               class="left size-full min-h-8 max-w-96 mb-1 ml-4">
                                    <mat-chip *ngFor="let contact of responseRequiredContacts"
                                              class="w-96 flex-initial">
                                        <ng-container [ngSwitch]="getContactType(contact)">
                                            <mat-icon *ngSwitchCase="SMS" aria-hidden="false" aria-label="SMS Text" matTooltip="SMS">
                                                perm_phone_msg
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="VOICE" aria-hidden="false" aria-label="Phone" matTooltip="Voice">
                                                phone
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="EMAIL" aria-hidden="false" aria-label="EMail" matTooltip="Email">
                                                email
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="CHAT" aria-hidden="false" aria-label="Chat" matTooltip="Chat">
                                                message
                                            </mat-icon>
                                        </ng-container>
                                        {{ contact.address }}
                                    </mat-chip>
                                </mat-chip-list>
                            </div>

                            <div class="flex flex-col w-full items-center">
                                <label class="text-center w-full ml-2">
                                    Response Required and Informational</label>
                                <mat-chip-list #chipListResponseRequiredAndInfo
                                               accessKey="responseRequiredAndInfo"
                                               class="left size-full min-h-8 max-w-96 mb-1 ml-4">
                                    <mat-chip *ngFor="let contact of responseRequiredAndInfoContacts"
                                              class="w-96 flex-initial">
                                        <ng-container [ngSwitch]="getContactType(contact)">
                                            <mat-icon *ngSwitchCase="SMS" aria-hidden="false" aria-label="SMS Text" matTooltip="SMS">
                                                perm_phone_msg
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="VOICE" aria-hidden="false" aria-label="Phone" matTooltip="Voice">
                                                phone
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="EMAIL" aria-hidden="false" aria-label="EMail" matTooltip="Email">
                                                email
                                            </mat-icon>
                                            <mat-icon *ngSwitchCase="CHAT" aria-hidden="false" aria-label="Chat" matTooltip="Chat">
                                                message
                                            </mat-icon>
                                        </ng-container>
                                        {{ contact.address }}
                                    </mat-chip>
                                </mat-chip-list>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="messageTypesEnabled"
                     class="grid mt-2 border-t border-[var(--cmn-text-alt)]">
                    <div class="flex-col mt-2">
                        <label class="ml-4">
                            Silenced</label>
                        <mat-chip-list #chipListSilenced
                                       accessKey="silenced"
                                       class="left size-full min-h-8 ml-2">
                            <mat-chip *ngFor="let contact of silencedContacts"
                                      class="w-96 flex-initial">
                                <ng-container [ngSwitch]="getContactType(contact)">
                                    <mat-icon *ngSwitchCase="SMS" aria-hidden="false" aria-label="SMS Text" matTooltip="SMS">
                                        perm_phone_msg
                                    </mat-icon>
                                    <mat-icon *ngSwitchCase="VOICE" aria-hidden="false" aria-label="Phone" matTooltip="Voice">
                                        phone
                                    </mat-icon>
                                    <mat-icon *ngSwitchCase="EMAIL" aria-hidden="false" aria-label="EMail" matTooltip="Email">
                                        email
                                    </mat-icon>
                                    <mat-icon *ngSwitchCase="CHAT" aria-hidden="false" aria-label="Chat" matTooltip="Chat">
                                        message
                                    </mat-icon>
                                </ng-container>
                                {{ contact.address }}
                            </mat-chip>
                        </mat-chip-list>
                    </div>
                </div>
            </div>
            <div *ngIf="object.group_ownership" class="form-section row-flex-2">
                <label class="mr10 mt10">Group Ownership:</label>
                <mat-chip-list>
                    <mat-chip (click)="openGroupPopup(group.id)" *ngFor="let group of object.group_ownership">
                        {{ group.name }}&nbsp;
                    </mat-chip>
                </mat-chip-list>
            </div>
            <div *ngIf="object.group_membership" class="form-section-2 row-flex-2">
                <label class="mr10 mt10">Member of:</label>
                <mat-chip-list>
                    <mat-chip (click)="openGroupPopup(group.id)" *ngFor="let group of object.group_membership">
                        {{ group.name }}
                    </mat-chip>
                </mat-chip-list>
            </div>
        </div>
    </mat-dialog-content>
</div>

<app-hourglass *ngIf="!loaded"></app-hourglass>
